import React from 'react';
import Layout from '../components/Layout';
import '../css/HomePageFirst.css'
import { Button } from '@mui/material';
import { StyledEngineProvider } from "@mui/material";
import CssBaseline from "@mui/material/CssBaseline";
import { ReactComponent as SparkleIcon } from '../assets/icons/Vector.svg';
import { ReactComponent as TickMark } from '../assets/icons/Group.svg';
import { Box, ImageList, ImageListItem, useTheme, useMediaQuery } from '@mui/material';

// Import community images
import community1 from '../assets/images/community/Rectangle 83.jpg';
import community2 from '../assets/images/community/Rectangle 84.jpg';
import community3 from '../assets/images/community/Rectangle 85.png';
import community4 from '../assets/images/community/Rectangle 86.png';
import community5 from '../assets/images/community/Rectangle 87.png';
import community6 from '../assets/images/community/Rectangle 88.png';
import community7 from '../assets/images/community/Rectangle 89.png';
import community8 from '../assets/images/community/Rectangle 90.png';

const itemData = [
  {
    img: community1,
    title: "Community Image 1"
  },
  {
    img: community2,
    title: "Community Image 2"
  },
  {
    img: community3,
    title: "Community Image 3"
  },
  {
    img: community4,
    title: "Community Image 4"
  },
  {
    img: community5,
    title: "Community Image 5"
  },
  {
    img: community6,
    title: "Community Image 6"
  },
  {
    img: community7,
    title: "Community Image 7"
  },
  {
    img: community8,
    title: "Community Image 8"
  }
]

function StandardImageList() {
  const theme = useTheme();
  const isXs = useMediaQuery(theme.breakpoints.down('sm'));
  const isSm = useMediaQuery(theme.breakpoints.between('sm', 'md'));

  const cols = isXs ? 1 : isSm ? 2 : 4;

  return (
    <Box sx={{ width: "95%", margin: "0 auto", marginBottom: "40px" }}>
      <ImageList cols={cols} gap={20}>
        {itemData.map((item) => (
          <ImageListItem key={item.img}>
            <img
              src={item.img}
              alt={item.title}
              loading="lazy"
            />
          </ImageListItem>
        ))}
      </ImageList>
    </Box>
  );
}



const HomePage = () => {
  return (
    <StyledEngineProvider injectFirst>
    <CssBaseline />
    <div className="page-container">
      <Layout pageTitle="My JoyNet &#128526;">
        <div className="rounded-componentHome rounded-component-margin">
          <div className="content-container">
            <div className="welcome-container">
              <span className='welcome-line1'>Welcome to Your Healing Community &#128075;</span>
            </div>
            <div className="welcome-subline-container">
              <span className='welcome-subline1'>At JoyNet, every conversation is a step towards healing. 
                Engage,share, and find comfort in a community that understands.
              </span>
            </div>
          </div>
        </div>

        <div className="rounded-component2 rounded-component-margin">
          <div className="left-section">
              <div className="left-section-welcome">
                <span className='welcome-line1'>
                  Navigating Your Joynet Journey
                </span>
              </div>
              <div className="left-section-subline">
                <span className='welcome-subline1'>Dive into our chatroom-style community. Start conversations, connect over shared experiences, and discover joy in every interaction.</span>
              </div>
              <div className="gradient-button-container">
                <Button 
                  variant="contained" 
                  className="gradient-button"
                  onClick={() => { window.location.href = '/myjoynet'; }}
                >
                  <SparkleIcon className='icon-style'/>
                  NAVIGATE TO MY JOYNET
                </Button>
              <div/>
            </div>
          </div>
          <div className="right-side">
            <div className="item-container">
              <div className="item-row">
                <TickMark className="tick-mark-icon" />
                <div className="item-content">
                  <div className="right-heading item-heading">Start Conversations</div>
                  <div className="right-content item-text">
                    Easily initiate discussions on topics close to your heart or join ongoing conversations
                  </div>
                </div>
              </div>

              <div className="item-row">
                <TickMark className="tick-mark-icon" />
                <div className="item-content">
                  <div className="right-heading item-heading">Engage with Others</div>
                  <div className="right-content item-text">
                    Respond, empathize, and share insights in a supportive and respectful environment.
                  </div>
                </div>
              </div>

              <div className="item-row">
                <TickMark className="tick-mark-icon" />
                <div className="item-content">
                  <div className="right-heading item-heading">Share and Discover</div>
                  <div className="right-content item-text">
                    Bring your favorite distractions or coping strategies to the table – be it music, art, or stories – and discover new ones from fellow members.
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        
        <div className="rounded-component3 rounded-component-margin">
            <div className="left-section-welcome-component3"> A Glimpse into Our World of Support & Joy</div>
            <StandardImageList />
        </div>
      </Layout>
    </div>
    </StyledEngineProvider>
  );
};

export default HomePage;
